import { CbhFeatureFlag, useCbhFlag } from "../FeatureFlags";

export function useLicenseFieldsRequirementsFlag() {
  return useCbhFlag(CbhFeatureFlag.HCP_LICENSE_FIELDS_REQUIREMENTS, {
    defaultValue: {},
  });
}
